import { render, staticRenderFns } from "./PrintDemo.vue?vue&type=template&id=334a0705&scoped=true&"
import script from "./PrintDemo.vue?vue&type=script&lang=js&"
export * from "./PrintDemo.vue?vue&type=script&lang=js&"
import style0 from "./PrintDemo.vue?vue&type=style&index=0&id=334a0705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334a0705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('334a0705')) {
      api.createRecord('334a0705', component.options)
    } else {
      api.reload('334a0705', component.options)
    }
    module.hot.accept("./PrintDemo.vue?vue&type=template&id=334a0705&scoped=true&", function () {
      api.rerender('334a0705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/PrintDemo.vue"
export default component.exports